import React from 'react';
import { Route, IndexRedirect } from 'react-router';

import App from './app/App';
import Login from './Login';
import ProjectV2 from './project-v2';
import CloneV2 from './clone-v2';
import PlanRoute from './plan';
import PatternDuplicationRoute from './PatternDuplication';
import Offer from './offer';
import Confirmation from './confirmation';
import NotFound from './not-found';
import SubscribeRoute from './subscribe/SubscribeRoute';
import SubscribeFormContainer from './subscribe/SubscribeFormContainer';
import SubscribeFormUserContainer from './subscribe/SubscribeFormUserContainer';

const routes = (
	<Route>
		<Route path="/">
			<IndexRedirect to="/login" />
		</Route>
		<Route path="/login(/:projectId)" component={Login} />
		<Route path="/subscribe" component={SubscribeRoute} />
		<Route
			path="/subscribe/new-account"
			component={SubscribeFormContainer}
		/>
		<Route
			path="/subscribe/user-sign"
			component={SubscribeFormUserContainer}
		/>
		<Route path="/app" component={App}>
			<Route index={1} path="/app/project-v2" component={ProjectV2} />
			<Route
				index={1}
				path="/app/project/:projectId/clone-v2"
				component={CloneV2}
			/>
			<Route
				index={2}
				path="/app/project/:projectId/plan"
				component={PlanRoute}
			/>
			<Route
				index={2}
				path="/app/project/:projectId/pattern-duplication"
				component={PatternDuplicationRoute}
			/>
			<Route
				index={3}
				path="/app/project/:projectId/offers(/:i_am_logged_in)"
				component={Offer}
			/>
			<Route
				index={4}
				path="/app/project/:projectId/offer/:estimateNumber"
				component={Confirmation}
			/>
		</Route>
		<Route path="/*" component={NotFound} />
	</Route>
);

export default routes;



// WEBPACK FOOTER //
// ./src/js/routes.js